import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ConfirmationAdditionalEmailsModel } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';

@Component({
    selector: 'pace-confirmation-additional-emails',
    templateUrl: './confirmation-additional-emails.component.html',
    styleUrls: ['./confirmation-additional-emails.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationAdditionalEmailsComponent implements OnInit {
    @Input()
    public model: ConfirmationAdditionalEmailsModel;

    @Input()
    public parentForm: FormArray;

    public additionalEmailAddressesForm: FormGroup;
    public additionalEmailAddressesFormChildren: FormArray;

    public constructor(
        private readonly formBuilder: FormBuilder,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly changeDetector: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        this.additionalEmailAddressesFormChildren = this.formBuilder.array([]);
        this.additionalEmailAddressesForm = this.formBuilder.group({
            children: this.additionalEmailAddressesFormChildren,
        });

        Promise.resolve(undefined)
            .then(() => {
                this.parentForm.push(this.additionalEmailAddressesForm);
            })
            .catch((error: Error) =>
                this.log.error(
                    'Error in ConfirmationAdditionalEmailsComponent -> ngOnInit -> parentForm.push: ',
                    JSON.stringify(error),
                ),
            );
    }

    public deleteEmailAddress(index: number): void {
        this.model.emailAddresses.removeModel(index);
        this.changeDetector.detectChanges();
    }

    public addEmailAddress(): void {
        this.model.addEmail();
        this.changeDetector.detectChanges();
    }
}
